export default __webpack_public_path__ + "static/char-32-anr-e3424846dc28a8e29f8ad29b0941f47f.gif";